import { render, staticRenderFns } from "./AccountStatement.vue?vue&type=template&id=ee89eec6&scoped=true"
import script from "./AccountStatement.vue?vue&type=script&lang=js"
export * from "./AccountStatement.vue?vue&type=script&lang=js"
import style0 from "./AccountStatement.vue?vue&type=style&index=0&id=ee89eec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee89eec6",
  null
  
)

export default component.exports